export type PublicBranding = {
  tenantDomain: boolean;
  displayName: string;
  primaryColor: string;
  secondaryColor: string;
  primaryTextColor: string;
  loginTitle: string | null;
  loginSubtitle: string | null;
  showPoweredByAot: boolean;
  logoLightUrl: string | null;
  logoDarkUrl: string | null;
  faviconUrl: string | null;
  unknownHost?: boolean;
  environment: string;
};

export const DEFAULT_BRANDING: PublicBranding = {
  tenantDomain: false,
  displayName: 'AOT OpsAI',
  primaryColor: '#0B63CE',
  secondaryColor: '#14B8A6',
  primaryTextColor: '#FFFFFF',
  loginTitle: 'Operational clarity for every site.',
  loginSubtitle: 'Edge-aware infrastructure monitoring and grounded operations intelligence.',
  showPoweredByAot: true,
  logoLightUrl: null,
  logoDarkUrl: null,
  faviconUrl: null,
  environment: 'local',
};

export function applyBranding(branding: PublicBranding) {
  const root = document.documentElement;
  root.dataset.environment = branding.environment;
  root.style.setProperty('--brand-primary', branding.primaryColor);
  root.style.setProperty('--brand-secondary', branding.secondaryColor);
  root.style.setProperty('--brand-primary-text', branding.primaryTextColor);
  let favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"][data-tenant-brand]');
  if (branding.faviconUrl) {
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      favicon.dataset.tenantBrand = 'true';
      document.head.insertAdjacentElement('beforeend', favicon);
    }
    favicon.href = branding.faviconUrl;
  } else {
    favicon?.remove();
  }
}

export function TenantBrandLockup({
  branding,
  dark = false,
  compact = false,
}: {
  branding: PublicBranding;
  dark?: boolean;
  compact?: boolean;
}) {
  const logo = dark
    ? branding.logoDarkUrl ?? branding.logoLightUrl
    : branding.logoLightUrl ?? branding.logoDarkUrl;
  return (
    <div className={`tenant-brand-lockup${compact ? ' compact' : ''}`}>
      {logo ? (
        <span className="tenant-logo-backing">
          <img src={logo} alt="" />
        </span>
      ) : (
        <span className="tenant-brand-mark" aria-hidden="true">
          {branding.displayName.slice(0, 1).toUpperCase()}
        </span>
      )}
      <span>
        <strong>{branding.displayName}</strong>
        {branding.showPoweredByAot && <small>Powered by AOT OpsAI</small>}
      </span>
    </div>
  );
}
